import React, { useEffect, useState } from 'react';
import './Profile.css';

import githubLogo from '../../assets/icons/github.png';
import linkedinLogo from '../../assets/icons/linkedin.png';
import myResume from '../../assets/resume/Fenofifaliana_CV_Developpeur.pdf';
import profilePicture from '../../assets/images/profile.png';

export default function Profile() {
    const [showBubble, setShowBubble] = useState(false);
    const [bubbleText, setBubbleText] = useState('');

    const bubbleMessages = [
        "Don’t poke me, unless you’re ready to pay a fine! 💰",
        "Hey! Careful where you tap! 😜",
        "Ouch! That hurts, try again and it’ll cost you! 🤑",
        "Hands off! You might pay the price! 💸",
        "Tap me and your wallet will cry 😅💵",
        "One poke = one coin, fair deal! 🪙",
        "Money, please! No free taps allowed! 💰",
        "Careful, this tap has a fee 💸⚠️",
    ];    

    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = profilePicture;
        link.as = 'image';
        link.type = 'image/png';
        document.head.appendChild(link);
        
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    const handleClick = () => {
        const randomIndex = Math.floor(Math.random() * bubbleMessages.length);
        setBubbleText(bubbleMessages[randomIndex]);
        setShowBubble(true);        
    };

    return (
        <div className='profile-wrapper'>
            <div className='profile-container'>
                <div className='profile-parent'>
                    <div className='profile-details'>
                        <div className='profile-details-name'>
                            <span className='primary-text'>
                                Salama tompoko ô, I'm <span className='highlighted-text'>Fenofifaliana</span>
                            </span>
                        </div>

                        <div className="profile-details-role">
                            <h1 className="primary-text">Passionate Developer</h1>
                            <p className="profile-role-tagline">
                                Driven by curiosity and creativity, I turn ideas into digital experiences—fueled by my passion for technology and its endless possibilities.
                            </p>
                        </div>

                        <div className='social-network-icons'>
                            <a href='https://www.linkedin.com/in/fenofifaliana-rafanomezantsoa-b87316211/' target="_blank" rel="noopener noreferrer">
                                <img src={linkedinLogo} alt="Linkedin"/>
                            </a>
                            <a href='https://github.com/Fullfifax' target="_blank" rel="noopener noreferrer">
                                <img src={githubLogo} alt="Github" />
                            </a>
                        </div>

                        <div className='profile-options'>
                            <a className='btn btn-hire' href="#contacts">Hire Me</a>
                            <a href={myResume} className='btn btn-download' download='CV_Fenofifaliana_FR.pdf'>
                                Download my resume in French
                            </a>
                        </div>
                    </div>

                    <div className='profile-picture'>
                        <div className='profile-picture-background'>
                            <img 
                                src={profilePicture} 
                                alt="Fenofifaliana" 
                                type="image/webp" 
                                loading="eager" 
                                decoding="async"
                                onClick={handleClick}
                            />
                            {showBubble && (
                                <div className="speech-bubble right">
                                    {bubbleText}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}